import React from "react";
import OphthalmologyDetail from "./OphthalmologyDetail";
import { Link } from "react-router-dom";
import { LuArrowRight } from "react-icons/lu";
import { IoIosArrowForward } from "react-icons/io";



const Ophthalmology = () => {
  return (
    <div className="gyanaecosmatic-headerss">
      <div className="page-title-bar page-title-bar-02">
        <div id="page-title-bar" className="page-title-bar page-title-bar-02">
          <div className="page-title-bar-overlay" />
          <div className="page-title-bar-inner">
            <div className="container">
              <div className="row row-xs-center">
                <div className="col-md-6">
                  <div className="page-title-bar-heading">
                    <h1 className="heading">OphthalmologyDetail</h1>
                  </div>
                </div>
                <div className="col-md-6">
                  <div id="page-breadcrumb" className="page-breadcrumb">
                    <div className="page-breadcrumb-inner">
                      <ul className="insight_core_breadcrumb">
                        <li className="level-1 top item-home">
                          <a>Home</a>
                        </li>
                        <IoIosArrowForward color="#fff" style={{position:'relative'}}/>
                        <li className="level-2 sub item-current tail current">
                          <span>Ophthalmology</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="page-title-area contact-page-title bg-3">
     <div className="container">
       <div className="page-title-content">
         <h2>Service Detail</h2>
         <ul>
         <li className="li-bloggg">
                <Link to='/'>Home </Link>
              </li>
              <li><LuArrowRight/></li>
           <li className="active">OphthalmologyDetail
           </li>
         </ul>
       </div>
     </div>
   </div> */}
      <OphthalmologyDetail />
      {/* <Testimonial/>
      <BookingForm/> */}

      {/* <Types/> */}
    </div>
  );
};

export default Ophthalmology;
